import FormClientesConocidos from "../componentes/FormClientesConocidos.vue";
import ListaClientesConocidos from "../componentes/ListaClientesConocidos.vue";

const routes = [
    ...route("/guardar-clientes-conocido", FormClientesConocidos, {
        Auth: true,
        ///req_admin: true
    }),
    ...route("/lista-clientes-conocido", ListaClientesConocidos, {
        Auth: true,
        //req_admin: true
    }),
];

function route(path, component = Default, meta = {}) {
    return [
        {
            path,
            component,
            meta,
        },
    ];
}

export default routes;
